import { Checkbox, Flex, Typography } from 'antd'
import { useCallback, useState } from 'react'
import { LayerGroup, useMap } from 'react-leaflet'

export default function LayerOverlay({ name, title, color, onChange, children }) {
  const map = useMap()
  const [checked, setChecked] = useState(false)

  const Layers = useCallback(() => {
    return checked && (
      <LayerGroup
        eventHandlers={{
          add(e) { map.fire('overlayadd', { name, layer: e.target }) },
          remove(e) { map.fire('overlayremove', { name, layer: e.target }) },
        }}
      >
        {children}
      </LayerGroup>
    )
  }, [map, checked, name, children])

  const handleCheck = (e) => {
    setChecked(e.target.checked)
    onChange?.(e.target.checked)
  }

  return (
    <>
      <Flex gap={8} align='center' justify='space-between' style={{ overflow: 'hidden' }}>
        <Checkbox checked={checked} onChange={handleCheck}/>
        <Typography.Text
          ellipsis={{ tooltip: title }}
          style={{
            flexGrow: 1,
            minWidth: 0,
            overflow: 'hidden'
          }}
        >
          {title}
        </Typography.Text>
        <div
          style={{
            background: color,
            borderRadius: '50%',
            width: 16,
            aspectRatio: 1,
            flexShrink: 0
          }}
        />
      </Flex>
      <Layers />
    </>
  )
}